import React from 'react';
import { DropdownSingle } from '../../app/common/sharedComponents/DropdownSingle';
import { IFocusAreaCategory, IFocusAreaOptions } from '../../app/@types/focusArea';
import { translateMealPeriodLabel } from '../../enums/labels/MealPeriod';

interface IFocusAreaSelect {
  focusAreaOptions: IFocusAreaOptions;
  selectedFocusArea: string;
  visit?: number;
  focusAreaCallback: (option: any) => void;
  isDisabled: boolean;
}

export function FocusAreaSelect ({
  focusAreaOptions,
  selectedFocusArea,
  visit,
  focusAreaCallback,
  isDisabled,
}: IFocusAreaSelect) {
  const formatCategoryLabel = (category: IFocusAreaCategory) => {
    const { categoryName, mealPeriod, outlet } = category;
    const mealPeriodLabel = mealPeriod ? ` - ${translateMealPeriodLabel(mealPeriod)}` : '';
    const outletLabel = outlet ? ` - ${outlet}` : '';
    return `${categoryName}${mealPeriodLabel}${outletLabel}`;
  };
  
  const getOptions = (focusAreaOptions: IFocusAreaOptions) => {
    if (focusAreaOptions && focusAreaOptions.categories) {
      return focusAreaOptions.categories.map((category) => ({
        label: formatCategoryLabel(category),
        value: `${category.categoryId}#$#${category.visit}`,
        category: category.categoryType,
      }));
    }
    return [];
  };

  const getDefaultOption = (focusAreaOptions: IFocusAreaOptions) => {
    if (selectedFocusArea && focusAreaOptions.categories) {
      const category = focusAreaOptions.categories.find(
        (category) =>
          category.categoryId === parseInt(selectedFocusArea) &&
          category.visit === visit
      );
      if (category) {
        return {
          label: category.categoryName,
          value: `${selectedFocusArea}#$#${visit}`,
        };
      }
    }
    return null;
  };

  return (
    <DropdownSingle
      isSearchable={false}
      disabled={isDisabled}
      defaultOption={getDefaultOption(focusAreaOptions)}
      callback={focusAreaCallback}
      options={getOptions(focusAreaOptions)}
    />
  );
}
